import React from 'react'
import {
    Briefcase,
    TrendingUp,
    Search,
    PieChart,
    Book,
    Folder,
    Layers,
    Sliders,
    Server,
    Settings,
    Database,
    Users,
    User,
    UserCheck,
    Grid,
    Clipboard,
    FileText,
    Repeat,
    Video,
    Activity,
    Gift,
    Mail,
    ArrowRight,
    ChevronRight,
    ChevronDown,
    ChevronUp,
    MessageCircle,
    List,
    BarChart2,
    Notebook,
    Building2,
    IdCard,
    HeartHandshake,
    ReceiptText,
    Landmark,
    Wallet,
    ShieldUser,
    CircleUserRound,
    UserLock,
    ScrollText,
    ClipboardList,
    Speech, BookUser, History, Euro, BookCheck, PawPrint
} from 'lucide-react'


const components = {
    'clipboard': Clipboard,
    'trendingUp' : TrendingUp,
    'briefcase': Briefcase,
    'pieChart': PieChart,
    'search': Search,
    'book': Book,
    'bookCheck': BookCheck,
    'notebook': Notebook,
    'layers': Layers,
    'sliders': Sliders,
    'server': Server,
    'settings': Settings,
    'database': Database,
    'users': Users,
    'user-check': UserCheck,
    'user': User,
    'grid': Grid,
    'fileText': FileText,
    'repeat': Repeat,
    'userBook': BookUser,
    'media': Video,
    'activity': Activity,
    'gift': Gift,
    'mail': Mail,
    'rightArrow': ArrowRight,
    'rightChevron': ChevronRight,
    'upChevron': ChevronUp,
    'downChevron': ChevronDown,
    'messageCircle': MessageCircle,
    'list': List,
    'bar-chart-2': BarChart2,
    'building': Building2,
    'idCard': IdCard,
    'heartHandshake': HeartHandshake,
    'receipt': ReceiptText,
    'bank': Landmark,
    'wallet': Wallet,
    'admin': ShieldUser,
    'profile': CircleUserRound,
    'userConfig': UserLock,
    'testament': ScrollText,
    'clipboardList': ClipboardList,
    'speech': Speech,
    'history': History,
    'euro': Euro,
    'animal': PawPrint
}

export const iconSelector = (icon, className, color) =>
    React.createElement(components[icon] || Folder, {className, color});
